import { Suspense } from 'react';
import { ActivityIndicator, ScrollView } from 'react-native';
import { Flex, StackScreen, useScreenSize } from '@banhala/ui-kit';
import { useHandleBackPressed, useReportTTFD } from 'shared/src/hooks';
import { AnalyticsScreen } from 'shared/src/context';
import { SettingSection } from './components/SettingSection';
import { SETTING_SECTIONS } from './constants';
import {
  useLogViewEvent,
  useOnPressSettingItem,
  usePersonalizationDescription,
} from './hooks';

const SettingContent = () => {
  const personalizationDescription = usePersonalizationDescription();
  const onPressItem = useOnPressSettingItem();

  useReportTTFD();
  useLogViewEvent();

  return (
    <ScrollView
      contentContainerStyle={{
        alignItems: 'center',
      }}
      showsVerticalScrollIndicator={false}
    >
      {SETTING_SECTIONS.map((section, index) => (
        <SettingSection
          key={section.key}
          section={section}
          personalizationDescription={personalizationDescription}
          showTopDivider={index > 0}
          onPressItem={onPressItem}
        />
      ))}
    </ScrollView>
  );
};

const Setting = () => {
  const { width } = useScreenSize();
  const { showBackButton, onPressBack } = useHandleBackPressed();

  return (
    <AnalyticsScreen screen="SETTING">
      <StackScreen
        title="설정"
        hideBackButton={!showBackButton}
        onPressBack={onPressBack}
      >
        <Suspense
          fallback={
            <Flex flex={1} width={width} margin={{ horizontal: 'auto' }}>
              <Flex.Center flex={1}>
                <ActivityIndicator />
              </Flex.Center>
            </Flex>
          }
        >
          <SettingContent />
        </Suspense>
      </StackScreen>
    </AnalyticsScreen>
  );
};

export default Setting;
